"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWhatsNewOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M31.6 16l-5.31-4.26L27 5l-6.77.74L16 .4l-4.26 5.31L5 5l.74 6.77L.4 16l5.31 4.26L5 27l6.77-.74L16 31.6l4.26-5.31L27 27l-.74-6.77zm-12.21 8.19L16 28.4l-3.39-4.21-5.38.58.58-5.38L3.6 16l4.21-3.39-.58-5.38 5.38.58L16 3.6l3.39 4.21 5.38-.58-.58 5.38L28.4 16l-4.21 3.39.58 5.38z" }),
        React.createElement("path", { d: "M16 19a1.5 1.5 0 101.53 1.49A1.49 1.49 0 0016 19zM15 10h2v7h-2z" })));
}
exports.default = SvgWhatsNewOutline;
//# sourceMappingURL=WhatsNewOutline.js.map